__turbopack_context__.v({
  "acheivername": "psy-optional-module__28dFTq__acheivername",
  "acheivername1": "psy-optional-module__28dFTq__acheivername1",
  "acheiverrank": "psy-optional-module__28dFTq__acheiverrank",
  "acheiverrank1": "psy-optional-module__28dFTq__acheiverrank1",
  "acheiverrank2": "psy-optional-module__28dFTq__acheiverrank2",
  "acheiverrank3": "psy-optional-module__28dFTq__acheiverrank3",
  "acheiverrank4": "psy-optional-module__28dFTq__acheiverrank4",
  "acheivertitle": "psy-optional-module__28dFTq__acheivertitle",
  "ansheet": "psy-optional-module__28dFTq__ansheet",
  "bgboxbg": "psy-optional-module__28dFTq__bgboxbg",
  "captcha": "psy-optional-module__28dFTq__captcha",
  "checkboxcontent": "psy-optional-module__28dFTq__checkboxcontent",
  "classesborder": "psy-optional-module__28dFTq__classesborder",
  "contactbox": "psy-optional-module__28dFTq__contactbox",
  "contactboxheight": "psy-optional-module__28dFTq__contactboxheight",
  "contactsubcontent": "psy-optional-module__28dFTq__contactsubcontent",
  "gshad": "psy-optional-module__28dFTq__gshad",
  "img": "psy-optional-module__28dFTq__img",
  "imgboxbelow": "psy-optional-module__28dFTq__imgboxbelow",
  "invalidCheck2": "psy-optional-module__28dFTq__invalidCheck2",
  "mainshead": "psy-optional-module__28dFTq__mainshead",
  "mbtableheading": "psy-optional-module__28dFTq__mbtableheading",
  "medalicon": "psy-optional-module__28dFTq__medalicon",
  "mobhead": "psy-optional-module__28dFTq__mobhead",
  "mobilemaillinks": "psy-optional-module__28dFTq__mobilemaillinks",
  "more": "psy-optional-module__28dFTq__more",
  "normalbutton": "psy-optional-module__28dFTq__normalbutton",
  "normalbutton2": "psy-optional-module__28dFTq__normalbutton2",
  "pagemaintitle": "psy-optional-module__28dFTq__pagemaintitle",
  "paybill": "psy-optional-module__28dFTq__paybill",
  "paybills": "psy-optional-module__28dFTq__paybills",
  "redunderline": "psy-optional-module__28dFTq__redunderline",
  "sectiontitle": "psy-optional-module__28dFTq__sectiontitle",
  "sectiontitle1": "psy-optional-module__28dFTq__sectiontitle1",
  "sectiontitle2": "psy-optional-module__28dFTq__sectiontitle2",
  "subhead": "psy-optional-module__28dFTq__subhead",
  "tableheading": "psy-optional-module__28dFTq__tableheading",
  "tablepara": "psy-optional-module__28dFTq__tablepara",
  "tablepara1": "psy-optional-module__28dFTq__tablepara1",
  "tablescroll": "psy-optional-module__28dFTq__tablescroll",
  "toppersupsc": "psy-optional-module__28dFTq__toppersupsc",
  "viewbutton": "psy-optional-module__28dFTq__viewbutton",
});
